import React from 'react';

/**
 * Render a label next to the guideline to indicate the goal of the guideline
 *
 * @param goal
 * @param scales
 * @returns goal text in the proper {x,y}
 */
const GoalLabel = ({goal, scales}) => {
  const padding = 3;
  return (
    <text
      className={'goal-label'}
      x={scales.xScale.range()[1] + padding}
      y={scales.yScale(goal) + padding}>
      {goal}
    </text>
  );
};

export default GoalLabel;
